import type { StatComponentSpec, StatTileBuilderMisc } from "../Processing/types";
import type { ControlPanelHandler } from "../widgetContract";
import { calendarWidgetDatePatch, isBound } from "./_shared";

// Stat tiles have no drills UI — apply only the athlete selection, or an
// invisible drill filter sticks that the configurator can never clear.
// resolveSubjectNames lists athlete names first, so slice by athlete count.
export const statControlPanel: ControlPanelHandler<StatComponentSpec> = (spec, patch) => {
  spec.stat_tile_builder_misc = {
    ...(spec.stat_tile_builder_misc as StatTileBuilderMisc),
    ...(patch.applyDate && !isBound(spec.stat_tile_builder_misc, "date", patch) && calendarWidgetDatePatch(patch.date)),
    ...(patch.applySubjects && !isBound(spec.stat_tile_builder_misc, "subject", patch) && {
      selectedSubjects: patch.subjects.selectedSubjects,
      selectedSubjectNames: patch.subjects.selectedSubjectNames.slice(
        0,
        patch.subjects.selectedSubjects.length,
      ),
    }),
  };
};
